import Reveal from "@/components/ui/Reveal";

/**
 * Our Story (#our-story): why we built inaraX. A centred heading over a centred column of
 * left-aligned paragraphs: the old question, the better one that led to inaraX,
 * what it does, and the result.
 */
export default function OurStory() {
  return (
    <section
      id="our-story"
      aria-labelledby="our-story-heading"
      className="scroll-mt-20 bg-mkt-surface px-margin-mobile md:px-margin-desktop py-size-xl"
    >
      <div className="max-w-[1440px] mx-auto">
        <Reveal className="max-w-3xl mx-auto text-center">
          <span className="font-label-md text-label-md text-mkt-primary uppercase tracking-widest">Our story</span>
          <h2
            id="our-story-heading"
            className="mt-size-sm font-display-lg text-[clamp(28px,3vw,44px)] leading-[1.15] tracking-[-0.02em] font-bold text-mkt-inarax-black text-balance"
          >
            Why we built inaraX
          </h2>
        </Reveal>

        <Reveal
          delayMs={100}
          className="mt-size-lg max-w-3xl mx-auto flex flex-col gap-size-sm text-left font-body-lg text-body-lg text-mkt-on-surface-variant"
        >
          <p className="font-bold text-mkt-inarax-black">A new model for enterprise learning.</p>
          <p>
            Traditional corporate learning starts with a simple question: &ldquo;What course should we give our
            employees?&rdquo;
          </p>
          <p>
            We believe the better question is: &ldquo;What does each person need to learn to do their job
            better?&rdquo;
          </p>
          <p>
            That question led us to build inaraX, an enterprise AI learning platform designed around the reality
            that every learner, role, and organization is different.
          </p>
          <p>
            inaraX combines AI-powered personalization, role-based learning, practical application, and human
            expertise to help organizations build the capabilities their workforce needs.
          </p>
          <p>
            We assess where people are, identify capability gaps, and create learning experiences that adapt to their
            roles, goals, and context while industry experts help ensure learning stays relevant to the real world.
          </p>
          <p>
            The result is learning that is more personal for the individual and more meaningful for the organization.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
